import React, { useState } from 'react';
import { Download, FileText, FileSpreadsheet, FileJson, Printer } from 'lucide-react';
import { ExportService } from '../../services/export.service';
import { Ticket } from '../../types';
import { Button } from '../shared';

interface ExportMenuProps {
    tickets: Ticket[];
    title?: string;
}

export const ExportMenu: React.FC<ExportMenuProps> = ({ tickets, title = 'tickets' }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleExport = (format: 'csv' | 'excel' | 'json' | 'pdf') => {
        const filename = `${title}_${new Date().toISOString().split('T')[0]}`;

        switch (format) {
            case 'csv':
                ExportService.exportToCSV(tickets, `${filename}.csv`);
                break;
            case 'excel':
                ExportService.exportToExcel(tickets, `${filename}.xlsx`);
                break;
            case 'json':
                ExportService.exportToJSON(tickets, `${filename}.json`);
                break;
            case 'pdf':
                ExportService.generatePDFReport(tickets, `Reporte de Tickets - ${title}`);
                break;
        }

        setIsOpen(false);
    };

    return (
        <div className="relative">
            <Button
                onClick={() => setIsOpen(!isOpen)}
                variant="secondary"
                size="sm"
            >
                <Download size={16} className="mr-2" />
                Exportar
            </Button>

            {isOpen && (
                <>
                    {/* Backdrop */}
                    <div
                        className="fixed inset-0 z-10"
                        onClick={() => setIsOpen(false)}
                    />

                    {/* Menu */}
                    <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border z-20 overflow-hidden">
                        <div className="py-1">
                            <button
                                onClick={() => handleExport('csv')}
                                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center transition"
                            >
                                <FileText size={16} className="mr-3 text-gray-400" />
                                Exportar como CSV
                            </button>
                            <button
                                onClick={() => handleExport('excel')}
                                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center transition"
                            >
                                <FileSpreadsheet size={16} className="mr-3 text-green-600" />
                                Exportar como Excel
                            </button>
                            <button
                                onClick={() => handleExport('json')}
                                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center transition"
                            >
                                <FileJson size={16} className="mr-3 text-blue-600" />
                                Exportar como JSON
                            </button>
                            <div className="border-t my-1"></div>
                            <button
                                onClick={() => handleExport('pdf')}
                                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center transition"
                            >
                                <Printer size={16} className="mr-3 text-red-600" />
                                Generar PDF
                            </button>
                        </div>
                        <div className="bg-gray-50 px-4 py-2 text-xs text-gray-500">
                            {tickets.length} ticket{tickets.length !== 1 ? 's' : ''} para exportar
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
